import * as React from "react"

const SvgCreatorNetwork = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.998 7.808a3.5 3.5 0 1 1 .497-1.998 7.96 7.96 0 0 1 3.44 3.194 1 1 0 1 1-1.736.992 5.94 5.94 0 0 0-2.202-2.188ZM13.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.514 15a7.95 7.95 0 0 0 4.5-1.373 3.5 3.5 0 1 0-1.476-1.435 5.9 5.9 0 0 1-3.007.808 1 1 0 1 0-.018 2Zm6.094-2.99a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M4.02 13.577a8.03 8.03 0 0 1 1.044-4.578A1 1 0 0 1 6.794 10 6 6 0 0 0 6 13.011a3.5 3.5 0 1 1-1.98.566m3.41 2.933a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCreatorNetwork
